/* globals $ */
// Loads data into corresponding form fields.
function kms_populate_form_data(el, data) {
    Object.keys(data).forEach(function(field) {
        if (field[0] != '_') { // Skip internal fields. (e.g. _csrf token)
            var form_field = el.find("[name='" + field +"']");
            if (form_field.length > 0) {
                form_field.val(data[field]);
            }
        }
    });
}
window.kms_populate_form_data = kms_populate_form_data;

function kms_load_previous_form_submission(el, callback) {
    $.ajax({
        url: el.attr('action'),
        type: 'GET',
        success: function(data) {
            kms_populate_form_data(el,data.data);
            if (callback) callback(data.data);
        }
    });
}
window.kms_load_previous_form_submission = kms_load_previous_form_submission;
